import { useForm } from 'react-final-form';
import colors from 'constants/colors';

export const SharePreview = () => {
  const form = useForm();
  const values = form.getState().values as Record<string, unknown>;

  const hasShare = !!values.has_share;
  if (!hasShare) return null;

  const buttonText = (values.share_alt as string) || 'Share with friends';
  const ctaColor = (values.cta_color as string) || colors.oathBlue;

  return (
    <section className="share-preview">
      <div className="share-preview__inner">
        <span className="share-preview__title h2-dtm">{form.getState().values?.share_title}</span>
        {form.getState().values?.share_description && (
          <span className="share-preview__description description">
            {form.getState().values?.share_description}
          </span>
        )}
        <div className="share-preview__cta">
          <button
            className="share-preview__cta-button"
            style={{ backgroundColor: ctaColor }}
            type="button"
          >
            {buttonText}
          </button>
        </div>
        {form.getState().values?.share_disclaimer && (
          <span className="share-preview__disclaimer">
            {form.getState().values?.share_disclaimer}
          </span>
        )}
      </div>
    </section>
  );
};
